import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "App-HowItW" }
const _hoisted_2 = { class: "App-HowItW-H" }
const _hoisted_3 = { class: "App-HowItW-Cont" }
const _hoisted_4 = { class: "App-HowItW-Icon" }
const _hoisted_5 = { class: "App-HowItW-Desc" }
const _hoisted_6 = { class: "App-HowItW-Cont" }
const _hoisted_7 = { class: "App-HowItW-Icon" }
const _hoisted_8 = { class: "App-HowItW-Desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_circle_check = _resolveComponent("circle-check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "App-HowItW-Header",
          "txt-center": ""
        }, [
          _createElementVNode("h1", {
            "txt-center": "",
            primary: ""
          }, "How it works"),
          _createElementVNode("p", { "txt-center": "" }, "Finding your fit... how to get started"),
          _createElementVNode("br")
        ], -1)),
        _createVNode(_component_el_row, { justify: "space-around" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 24,
              lg: 11
            }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createElementVNode("h3", {
                  "f-w-700": "",
                  style: {"margin-left":"20px"}
                }, "For Founders", -1)),
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.founderSteps, (step) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "App-HowItW-Item",
                      key: step.description.slice(0, 16)
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_circle_check)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(step.description), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 24,
              lg: 11
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createElementVNode("h3", {
                  "f-w-700": "",
                  style: {"margin-left":"20px"}
                }, "For Talents", -1)),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talentSteps, (step) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "App-HowItW-Item",
                      key: step.description.slice(0, 16)
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_circle_check)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(step.description), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}